
<template>
  <div class="yxtbiz-arrange-statistics">
    <!-- 集团版机构选择 -->
    <yxtbiz-group-org-select
      v-if="isGroupFun"
      v-model="selectedGroup"
      class="mr12"
      :placeholder="$t('pc_ote_lbl_group_select_orgId')"
      @change="setSelectedGroup($event,params,getDetail)">
    </yxtbiz-group-org-select>
    <div v-if="!isLoopExamAll" class="yxtbiz-arrange-statistics__row">
      <yxt-row :gutter="12" type="flex">
        <template v-if="showArrangeCount">
          <yxt-col :span="6">
            <div class="yxtbiz-arrange-statistics__block">
              <!-- 参与人数 -->
              <yxt-row>
                <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">
                  {{ $t('pc_ote_lbl_attendcount') }}
                  <yxt-tooltip :content="$t('pc_ote_lbl_attendcounttip'/** 累计参加过考试的所有人数 */)" placement="top">
                    <yxt-svg icon-class="question-cirlce-o"
                            width="14px"
                            height="15px"
                            class="ml4 color-gray-7 hand"/>
                  </yxt-tooltip>
                </h3>
              </yxt-row>
              <yxt-row class="mt8 font-size-28 lh36">{{ baseInfo.answerQty || 0 }}</yxt-row>
              <yxt-divider class="yxtbiz-arrange-statistics__block-line opacity-5"></yxt-divider>
              <div class="lh20 font-size-12 flex flex-wrap">
                <span class="d-in-flex flex-shrink-0 minw-p-50 flex-g-1 pr8 mb4"><span class="mr8 color-gray-7">{{ $t('pc_ote_lbl_absentcount') }}</span>{{ baseInfo.missQty || 0 }}</span>
                <span class="d-in-flex flex-shrink-0 mb4"><span class="mr8 color-gray-7">{{ $t('pc_ote_lbl_attendrate') }}</span>{{ parseFloat(((baseInfo.answerQtyRate || 0) * 100).toFixed(1)) }}%</span>
                <span class="d-in-flex flex-shrink-0 minw-p-50"><span class="mr8 color-gray-7">{{ $t('pc_ote_lbl_arrangecount') }}</span>{{ baseInfo.totalQty || 0 }}</span>
              </div>
            </div>
          </yxt-col>
          <yxt-col :span="6">
            <div class="yxtbiz-arrange-statistics__block">
              <!-- 参与人次 -->
              <yxt-row>
                <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">
                  {{ $t('pc_ote_lbl_attendtimes') }}
                  <yxt-tooltip :content="$t('pc_ote_lbl_attendtimesrate') + '=' + $t('pc_ote_lbl_attendtimes') + '/' + $t('pc_ote_lbl_arrangecount')" placement="top">
                    <yxt-svg icon-class="question-cirlce-o"
                            width="14px"
                            height="15px"
                            class="ml4 color-gray-7 hand"/>
                  </yxt-tooltip>
                </h3>
              </yxt-row>
              <yxt-row class="mt8 font-size-28 lh36">{{ baseInfo.answerPersonTime || 0 }}</yxt-row>
              <yxt-divider class="yxtbiz-arrange-statistics__block-line opacity-5"></yxt-divider>
              <!-- 参与人次率 -->
              <yxt-row class="font-size-12 lh20">
                <span class="color-gray-7 mr8">{{ $t('pc_ote_lbl_attendtimesrate') }}</span>
                <span>{{ parseFloat(((baseInfo.answerPersonTimeRate || 0) * 100).toFixed(1)) }}%</span>
              </yxt-row>
              <!-- 安排人数 -->
              <yxt-row class="font-size-12 lh20 mt4">
                <span class="color-gray-7 mr8">{{ $t('pc_ote_lbl_arrangecount') }}</span>
                <span>{{ baseInfo.totalQty || 0 }}</span>
              </yxt-row>
            </div>
          </yxt-col>
        </template>
        <template v-else>
          <yxt-col :span="6">
            <div class="yxtbiz-arrange-statistics__block">
              <!-- 参与人数 -->
              <yxt-row>
                <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">{{ $t('pc_ote_lbl_attendcount') }}
                  <yxt-tooltip :content="$t('pc_ote_lbl_attendcounttip'/** 累计参加过考试的所有人数 */)" placement="top">
                    <yxt-svg icon-class="question-cirlce-o"
                            width="14px"
                            height="15px"
                            class="ml4 color-gray-7 hand"/>
                  </yxt-tooltip>
                </h3>
              </yxt-row>
              <yxt-row class="mt8 font-size-28 lh36">{{ baseInfo.answerQty || 0 }}</yxt-row>
            </div>
          </yxt-col>
          <yxt-col :span="6">
            <div class="yxtbiz-arrange-statistics__block">
              <!-- 参与人次 -->
              <yxt-row>
                <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">
                  {{ $t('pc_ote_lbl_attendtimes') }}
                </h3>
              </yxt-row>
              <yxt-row class="mt8 font-size-28 lh36">{{ baseInfo.answerPersonTime || 0 }}</yxt-row>
            </div>
          </yxt-col>
        </template>
        <yxt-col :span="6">
          <div class="yxtbiz-arrange-statistics__block">
            <div class="pr zindex2">
              <!-- 通过率 -->
              <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">
                {{ $t('pc_ote_lbl_passingrate') }}
                <yxt-tooltip :content="$t('pc_ote_lbl_passingrate') + '=' + $t('pc_ote_lbl_passingpersons') + '/' + $t('pc_ote_lbl_attendcount')" placement="top">
                  <yxt-svg icon-class="question-cirlce-o"
                           width="14px"
                           height="15px"
                           class="ml4 color-gray-7 hand"/>
                </yxt-tooltip>
              </h3>
            </div>
            <div v-if="!isLoading" class="pr zindex1">
              <!-- 合格率 -->
              <OteGuage :rate="baseInfo.passRate || 0" :rateName="$t('pc_ote_lbl_passingrate')" uniqueKey="1"/>
            </div>
            <div class="lh20 font-size-12 flex flex-wrap mt8">
              <span class="d-in-flex maxw-p-100 flex-shrink-0 flex-g-1 pr8 mb4"><span class="mr8 color-gray-7">{{ $t('pc_ote_lbl_passingpersons'/** 通过人数 */) }}</span>{{ baseInfo.passQty || 0 }}</span>
              <span class="d-in-flex flex-shrink-0 mb4"><span class="mr8 color-gray-7">{{ $t('pc_ote_lbl_oncepassrate') }}</span>{{ baseInfo.oncePassRate }}%</span>
            </div>
          </div>
        </yxt-col>
        <yxt-col :span="6">
          <div class="yxtbiz-arrange-statistics__block">
            <yxt-row class="pr zindex2">
              <!-- 优秀率 -->
              <h3 class="lh22 font-size-14 mt0 mb0 bold-400 flex-align-center">
                {{ $t('pc_ote_lbl_excellentrate') }}
                <yxt-tooltip :content="$t('pc_ote_lbl_excellentrate') + '=' + $t('pc_ote_lbl_excellentpersons') + '/' + $t('pc_ote_lbl_attendcount')" placement="top">
                  <yxt-svg icon-class="question-cirlce-o"
                           width="14px"
                           height="15px"
                           class="ml4 color-gray-7 hand"/>
                </yxt-tooltip>
              </h3>
            </yxt-row>
            <yxt-row v-if="scoreInfo.excellenceScore > 0" class="">
              <OteGuage v-if="!isLoading"
                        :rate="baseInfo.excellentRate || 0"
                        :rateName="$t('pc_ote_lbl_excellentrate')"
                        uniqueKey="2"/>
            </yxt-row>
            <div v-if="scoreInfo.excellenceScore === 0" class="color-gray-7 text-center mt40">
              <yxt-svg icon-class="set"
                        width="16px"
                        height="16px"
                        class="v-middle mr4"
                        :remote-url='mediaUrl' />
              <!-- 未设置优秀分数～ -->
              <span class="font-size-14 ml4 lh20 v-mid">{{ $t('pc_ote_msg_noexcellentscoreset') }}</span>
            </div>
          </div>
        </yxt-col>
      </yxt-row>
    </div>
    <div class="yxtbiz-arrange-statistics__row yxtbiz-arrange-statistics__block">
      <div>
        <!-- 分值统计 -->
        <span class="font-size-16 lh22 font-bold">{{ $t('pc_ote_lbl_scoreanalysis') }}</span>
      </div>
      <!-- <yxt-divider class="yxtbiz-arrange-statistics__head-line"></yxt-divider> -->
      <div class="yxtbiz-arrange-statistics__content-row">
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-all"
                   width="48px"
                   height="48px"></yxt-svg>
          <!-- 试卷总分 -->
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_exampapertotalscore') }}</span>
          <h3 class="font-size-24 lh32 mt4 mb0">{{ scoreInfo.totalScore }}</h3>
        </div>
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-pass"
                   width="48px"
                   height="48px"></yxt-svg>
          <!-- 通过分数 -->
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_passscore') }}</span>
          <h3 class="font-size-24 lh32 mt4 mb0">{{ scoreInfo.passScore }}</h3>
        </div>
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-great"
                   width="48px"
                   height="48px"></yxt-svg>
          <!-- 优秀分数 -->
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_excellentscore') }}</span>
          <h3 v-if="scoreInfo.excellenceScore > 0" class="font-size-24 lh32 mt4 mb0">{{ scoreInfo.excellenceScore }}</h3>
          <h3 v-else class="font-size-24 lh32 mt4 mb0">--</h3>
        </div>
        <!-- 最高分 -->
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-max"
                   width="48px"
                   height="48px"></yxt-svg>
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_highestscore') }}</span>
          <yxt-tooltip v-if="scoreInfo.highestScoreFullname" :content="`${scoreInfo.highestScoreFullname}${scoreInfo.highestScoreUserName ? `（${scoreInfo.highestScoreUserName}）` : ''}`" placement="top">
            <h3 class="font-size-24 lh32 mt4 mb0">{{ parseFloat((scoreInfo.highestScore).toFixed(2)) }}</h3>
          </yxt-tooltip>
          <h3 v-else class="font-size-24 lh32 mt4 mb0">--</h3>
        </div>
        <!-- 最低分 -->
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-min"
                   width="48px"
                   height="48px"></yxt-svg>
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_lowestscore') }}</span>
          <yxt-tooltip v-if="scoreInfo.minimumScoreFullname" :content="`${scoreInfo.minimumScoreFullname}${scoreInfo.minimumScoreUserName ? `（${scoreInfo.minimumScoreUserName}）` : ''}`" placement="top">
            <h3 class="font-size-24 lh32 mt4 mb0">{{ parseFloat((scoreInfo.minimumScore).toFixed(2)) }}</h3>
          </yxt-tooltip>
          <h3 v-else class="font-size-24 lh32 mt4 mb0">--</h3>
        </div>
        <!-- 平均分 -->
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-score-avg"
                   width="48px"
                   height="48px"></yxt-svg>
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_avgscore') }}</span>
          <h3 v-if="scoreInfo.averageScore > 0" class="font-size-24 lh32 mt4 mb0">{{ parseFloat((scoreInfo.averageScore).toFixed(2)) }}</h3>
          <h3 v-else class="font-size-24 lh32 mt4 mb0">{{ scoreInfo.averageScore }}</h3>
        </div>
        <!-- 平均耗时 -->
        <div class="yxtbiz-arrange-statistics__content">
          <yxt-svg :remote-url="mediaUrl"
                   icon-class="analysis-time-cost"
                   width="48px"
                   height="48px"></yxt-svg>
          <span class="font-size-12 lh20 color-gray-8 mt8">{{ $t('pc_ote_lbl_avgtimeconsuming') }}(min)</span>
          <h3 v-if="scoreInfo.averageTime > 0" class="font-size-24 lh32 mt4 mb0">{{ parseFloat((scoreInfo.averageTime).toFixed(1)) }}</h3>
          <h3 v-else class="font-size-24 lh32 mt4 mb0">{{ scoreInfo.averageTime }}</h3>
        </div>
      </div>
    </div>
    <div class="yxtbiz-arrange-statistics__row yxtbiz-arrange-statistics__block">
      <template v-if="isLoopExamAll">
        <div class="yxtbiz-arrange-statistics__block-bar">
          <!-- 各批次情况变化曲线 -->
          <span class="font-size-16 lh24 font-bold">{{ $t('pc_ote_lbl_accuracyofbatch') }}</span>
          <div class="yxtbiz-arrange-statistics__table-tab">
            <yxt-radio-group v-model="barSource" class="radio-active-border" @change="changeSource">
              <yxt-radio-button v-for='(item, index) in sourceList' :key="index" :label="item.value">{{ item.label }}</yxt-radio-button>
            </yxt-radio-group>
          </div>
        </div>
        <!-- <yxt-divider class="yxtbiz-arrange-statistics__head-line"></yxt-divider> -->
        <div class="pb16 mt12">
          <BarChart
            class="pt20"
            :chartType='ChartType.line'
            :dataType='chartDataType'
            :dataList="graphData" />
        </div>
      </template>
      <template v-else>
        <div class="yxtbiz-arrange-statistics__block-bar">
          <!-- 正确率统计 -->
          <span class="font-size-16 lh24 font-bold">{{ $t('pc_ote_lbl_accuracysta') }}</span>
          <div class="yxtbiz-arrange-statistics__table-tab">
            <yxt-radio-group v-model="barSource" class="radio-active-border" @change="changeSource">
              <yxt-radio-button v-for='(item, index) in sourceList' :key="index" :label="item.value">{{ item.label }}</yxt-radio-button>
            </yxt-radio-group>
          </div>
        </div>
        <div class="pb16 mt12">
          <BarChart
            class="pt20"
            :chartType='ChartType.bar'
            :dataType='ChartDataType.percent'
            :dataList="histoData" />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import BarChart from './components/chart/BarChart';
import OteGuage from './components/OteGuage';
import { getArrangeAnalysis } from './arrange.service';
import { ChartDataType, ChartType } from './enums';
import { SvgMediaUrl, QUES_TYPE_NAMES, QUES_LEVEL_NAMES } from './const';
import { loadScript } from './utils';
import groupOrg from './groupOrg';
export default {
  name: 'YxtbizArrangeStatistics',
  name_zh: '考试统计分析组件',
  components: {
    OteGuage,
    BarChart
  },
  mixins: [groupOrg],
  props: {
    // 考试安排ID
    arrangeId: {
      type: String,
      default: '',
      desc: '考试安排ID',
      setter: 'StringSetter'
    },
    // 循环的批次ID
    batchId: {
      type: String,
      default: '',
      desc: '循环的批次ID',
      setter: 'StringSetter'
    },
    // 第三方的批次ID
    btid: {
      type: String,
      default: '',
      desc: '第三方的批次ID',
      setter: 'StringSetter'
    },
    // 是否显示安排人数
    showArrangeCount: {
      type: Boolean,
      default: true,
      desc: '是否显示安排人数',
      setter: 'BooleanSetter'
    },
    grouporgProjectCenter: {
      type: Boolean,
      default: false,
      desc: '是否集团服务功能',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      ChartDataType,
      ChartType,
      graphData: [],
      params: {},
      barSource: 0,
      mediaUrl: SvgMediaUrl,
      customColor: 'inear-gradient(90deg, #2F5AFF 0%, #4F92FF 100%);',
      histoData: [],
      histoTypeData: [],
      histoLevelTypeData: [],
      histoPointsData: [],
      histoAverageScore: [],
      histoOncePassRate: [],
      histoPassRate: [],
      baseInfo: {},
      scoreInfo: {},
      typeRate: {},
      levelTypeRate: {},
      pointsTypeRate: {},
      chartDataType: ChartDataType.number,
      isLoading: true
    };
  },
  computed: {
    isLoopExam() {
      return this.baseInfo.dimensionType === 1;
    },
    isLoopExamAll() {
      return this.isLoopExam && !this.batchId;
    },
    sourceList() {
      return this.isLoopExamAll
        ? [{
          label: this.$t('pc_ote_lbl_avgscore'), // 平均分
          value: 3
        },
        {
          label: this.$t('pc_ote_lbl_passingrate'), // 通过率
          value: 4
        },
        {
          label: this.$t('pc_ote_lbl_oncepassrate'), // 一次通过率
          value: 5
        }
        ]
        : [
          {
            label: this.$t('pc_ote_lbl_questiontype'), // 题型
            value: 0
          },
          {
            label: this.$t('pc_ote_lbl_difficulty'), // 难度
            value: 1
          },
          {
            label: this.$t('pc_ote_lbl_assessmentpoint'), // 考核点
            value: 2
          }
        ];
    },
    isGroupFun() {
      return !!this.isGrouporgProjectCenter || this.grouporgProjectCenter;
    }
  },
  created() {
    if (window.G2 && window.echarts) {
      this.getDetail();
    } else {
      this.loadAllScript().then(() => {
        this.getDetail();
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  methods: {
    // 对外提供的刷新页面数据方法
    refresh() {
      // this.getDetail()
    },
    loadAllScript() {
      const loadG2 = loadScript(this.$imagesBaseUrl + 'npm/antv/g2/4.1.37/dist/g2.min.js', true);
      const loadEcharts = loadScript(this.$imagesBaseUrl + 'npm/echarts-5.2.2/dist/echarts.min.js', true);
      const scriptLoader = [];
      !window.G2 && scriptLoader.push(loadG2);
      !window.echarts && scriptLoader.push(loadEcharts);
      return Promise.all(scriptLoader);
    },
    getDetail() {
      this.isLoading = true;
      this.params.batchId = this.batchId;
      this.params.thirdBatchId = this.btid;
      getArrangeAnalysis(this.arrangeId, this.params, this.isGroupFun).then(res => {
        this.isLoading = false;
        this.info = res;
        this.baseInfo = res.baseInfo;
        this.baseInfo.passRate = parseFloat((res.baseInfo.passRate * 100).toFixed(1)); // 通过率
        this.baseInfo.oncePassRate = parseFloat((res.baseInfo.oncePassRate * 100).toFixed(1)); // 一次通过率
        this.baseInfo.excellentRate = parseFloat((res.baseInfo.excellentRate * 100).toFixed(1)); // 优秀率
        this.scoreInfo = res.scoreInfo;
        this.scoreInfo.averageTime = parseFloat(this.scoreInfo.averageTime.toFixed(1));
        this.accuracyRate = res.accuracyRate; // 题型、难度和考核点正确率
        this.getHistoData();
        if (this.isLoopExamAll) {
          this.barSource = 3;
          this.changeSource();
        }
        this.$forceUpdate();
      });
    },
    // 切换题型/难度/考核点
    changeSource() {
      this.chartDataType = ChartDataType.number;
      switch (this.barSource) {
        case 0:
          this.histoData = this.histoTypeData;
          break;
        case 1:
          this.histoData = this.histoLevelTypeData;
          break;
        case 2:
          this.histoData = this.histoPointsData;
          break;
        case 3:
          this.graphData = this.histoAverageScore;
          break;
        case 4:
          this.graphData = this.histoPassRate;
          this.chartDataType = ChartDataType.percent;
          break;
        case 5:
          this.graphData = this.histoOncePassRate;
          this.chartDataType = ChartDataType.percent;
          break;
        default:
          this.histoData = [];
          break;
      }
    },
    // 获取题型/难度/考核点正确率统计数据
    getHistoData() {
      const vm = this;
      // 正确率统计
      if (this.accuracyRate) {
        const accR = this.accuracyRate;
        const typeList = [];
        const levelTypeList = [];
        const pointsList = [];
        // 题型正确率
        if (accR.quesType && accR.quesType.length > 0) {
          accR.quesType.forEach(function(e) {
            typeList.push({
              type: vm.getTypeName(e.key),
              value: parseFloat((e.value * 10000 / 100).toFixed(2))
            });
          });
        }
        // 难度正确率
        if (accR.difficulty && accR.difficulty.length > 0) {
          accR.difficulty.forEach(function(e) {
            levelTypeList.push({
              type: vm.getLevelTypeName(e.key),
              value: parseFloat((e.value * 10000 / 100).toFixed(2))
            });
          });
        }
        // 考核点正确率
        if (accR.point && accR.point.length > 0) {
          accR.point.forEach(function(e) {
            pointsList.push({
              type: e.key,
              value: parseFloat((e.value * 10000 / 100).toFixed(2))
            });
          });
        }
        this.$nextTick(() => {
          this.histoData = this.getEchartHistoData(typeList, true, 'type', 1); // 把题型正确率赋给默认值
          this.histoTypeData = this.histoData;
          this.histoLevelTypeData = this.getEchartHistoData(levelTypeList, true, 'type', 1);
          this.histoPointsData = this.getEchartHistoData(pointsList, true, 'type', 1);
        });
      }
      // 各批次情况变化曲线
      const datas = this.info.arrangeBatchSta;
      if (datas) {
        // averageScore 平均分
        // oncePassRate 一次通过率
        // passRate 通过率
        this.histoAverageScore = this.getEchartHistoData(datas.averageScore);
        this.histoOncePassRate = this.getEchartHistoData(datas.oncePassRate, true);
        this.histoPassRate = this.getEchartHistoData(datas.passRate, true);
      }
    },
    getEchartHistoData(apiLi, percentage, nameKey, percentData = 100) {
      return [{
        data: !apiLi
          ? []
          : apiLi.map((e) => ({
            name: nameKey ? e[nameKey] : this.$t('pc_ote_lbl_index', [e.index]),
            value: !percentage ? e.value : (e.value * percentData),
            txtValue: e.value === null ? '--' : '',
            rate: e.value * percentData + '%'
          }))
      }];
    },
    // 题型
    getTypeName(val) {
      return QUES_TYPE_NAMES.length > val ? this.$t(QUES_TYPE_NAMES[val]) : '';
    },
    // 难度
    getLevelTypeName(val) {
      return QUES_LEVEL_NAMES[val] ? this.$t(QUES_LEVEL_NAMES[val]) : '';
    }
  }
};
</script>
